/** Portfolio copy & links — keys match `.env.example` */
const trim = (value: string | undefined) => value?.trim() || undefined;

export const portfolioEnv = {
	name: trim(process.env.REACT_APP_PORTFOLIO_NAME) ?? "",
	role:
		trim(process.env.REACT_APP_PORTFOLIO_ROLE) ??
		"React & TypeScript Developer",
	tagline:
		trim(process.env.REACT_APP_PORTFOLIO_TAGLINE) ??
		"Mini-apps showcasing UI, logic, and API integration — built for learning and portfolio.",
	demosIntro: trim(process.env.REACT_APP_PORTFOLIO_DEMOS_INTRO),
	links: {
		siteArchive: trim(process.env.REACT_APP_SITE_URL_ARCHIVE),
		gitlabPersonal: trim(process.env.REACT_APP_GITLAB_URL_PERSONAL),
		gitlabWork: trim(process.env.REACT_APP_GITLAB_URL_WORK),
		github: trim(process.env.REACT_APP_GITHUB_URL),
		linkedIn: trim(process.env.REACT_APP_LINKEDIN_URL),
	},
} as const;

export type PortfolioLink = {
	label: string;
	href: string;
};

/** Outbound links for hero CTAs (archive URL is footer-only). */
export const portfolioHeroLinks: PortfolioLink[] = [
	{ label: "GitHub", href: portfolioEnv.links.github ?? "" },
	{ label: "GitLab", href: portfolioEnv.links.gitlabPersonal ?? "" },
	{ label: "GitLab (work)", href: portfolioEnv.links.gitlabWork ?? "" },
	{ label: "LinkedIn", href: portfolioEnv.links.linkedIn ?? "" },
].filter((link): link is PortfolioLink => Boolean(link.href));

/** Outbound links for footer (archive + social). */
export const portfolioFooterLinks: PortfolioLink[] = [
	{ label: "Archive", href: portfolioEnv.links.siteArchive ?? "" },
	{ label: "GitLab", href: portfolioEnv.links.gitlabPersonal ?? "" },
	{ label: "GitLab (work)", href: portfolioEnv.links.gitlabWork ?? "" },
	{ label: "GitHub", href: portfolioEnv.links.github ?? "" },
	{ label: "LinkedIn", href: portfolioEnv.links.linkedIn ?? "" },
].filter((link): link is PortfolioLink => Boolean(link.href));
